import React from 'react';
import PropTypes from 'prop-types';

export const Rejected = ({ width, height, ...props }) => (
  <svg
    data-icon='rejected'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m12 17.425-9-9L4.4 7l7.6 7.6L17.6 9H13V7h8v8h-2v-4.575l-7 7Z'
    />
  </svg>
);

Rejected.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Rejected.defaultProps = {
  width: 24,
  height: 24,
};
